/* eslint-disable react/jsx-no-target-blank */
import React from "react"
import {Trans, useTranslation} from "react-i18next"
import {useNavigate} from "react-router-dom"
import "../../css/SplashView.css"
import {useConfig} from "../../hooks/useConfig"
import {useParticipant} from "../../hooks/useParticipant"
import {useBoothSession} from "../../hooks/useBoothSession"
import SplashForm, {PrivacyPolicyLink} from "../views/SplashForm"
import BigButton from "../buttons/BigButton"
import {Participant} from "../../library/Participant"
import GallerySample from "../views/GallerySample"
import Box from "@mui/material/Box"
import {Fade} from "@mui/material"

function SplashPage() {
  const {t} = useTranslation()
  const navigate = useNavigate()

  const config = useConfig()
  const {participant, setParticipant} = useParticipant(config.presetCode)
  const {clearImages} = useBoothSession()

  const handleEnter = (newParticipant: Participant) => {
    clearImages()
    setParticipant(newParticipant)
    navigate(`/${config.presetCode}/camera`)
  }

  const theme = config.theme
  const {dataCapture} = config
  const showForm = dataCapture.emailOn || dataCapture.firstNameOn || dataCapture.lastNameOn || dataCapture.phoneNumberOn
  const buttonTitle = config.buttons.splashJoin ? config.buttons.splashJoin.title : t("splash.continue")

  return (
    <section className="splashContainer">
      <Box
        width="100%"
        maxWidth={1024}
        sx={{mt: 2, justifySelf: "center"}}
      >
        <GallerySample
          gallery={config.gallery}
          readyThreshold={1}
          fallbackImageUrl={config.aiEffectSequence?._embedded.preview?._links.image.href}
        />
      </Box>

      <Fade in timeout={2000}>
        <header id="headingGroup">
          <div>
            <h1 style={theme.textStyle}>{theme.heading}</h1>
            {theme.subheading && <h2 style={theme.textStyle}>{theme.subheading}</h2>}
          </div>
        </header>
      </Fade>

      <Box
        sx={{
          "@keyframes slideUpFade": {
            from: {opacity: 0, transform: "translateY(20px)"},
            to: {opacity: 1, transform: "translateY(0)"},
          },
          animation: "slideUpFade 600ms ease-out forwards",
        }}
      >
        {showForm ? (
          <SplashForm
            theme={config.theme}
            currentParticipant={participant}
            emailOn={dataCapture.emailOn}
            firstNameOn={dataCapture.firstNameOn}
            lastNameOn={dataCapture.lastNameOn}
            phoneNumberOn={dataCapture.phoneNumberOn}
            handleSuccess={(participant) => handleEnter(participant)}
          />
        ) : (
          <>
            <BigButton
              sx={{mt: 4, width: "100%", mx: "auto"}}
              onClick={() => handleEnter(participant)}
            >
              {buttonTitle}
            </BigButton>
            <PrivacyPolicyLink textColor={theme.textColor}/>
          </>
        )}
      </Box>

      {!config.hideAttribution && (
        <div id="poweredBy">
          <a
            href={theme.poweredBy.url}
            target="_blank"
            style={theme.textStyle}
          >
            <Trans
              i18nKey="splash.poweredBy"
              values={{company: theme.poweredBy.entity}}
            >
              Powered by <span className="entity">Simple Booth</span>
            </Trans>
          </a>
        </div>
      )}
    </section>
  )
}

export default SplashPage
